import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Progress } from 'antd';
import _ from 'lodash';

const QuestProgress = (props) => {
    const answeredNormalQns = useMemo(() => {
        return _.filter(props.answerList, function (o) {
            return (
                o.option !== null ||
                (o.mOptions !== null &&
                    o.mOptions &&
                    o.mOptions.length > 0) ||
                o.floatAns||
                (o.textAns !== null && o.textAns !== '') ||
                (o.file_answers && o.file_answers.length > 0) ||
                (o.diagnostic_answers &&
                    o.diagnostic_answers.some(function (item) {
                        return item.diagnostic_value !== null;
                    })) ||
                o.slider_eq_5d_answer
            );
        });
    }, [props.answerList]);

    const total = useMemo(() => {
        const qstnsArray = [];
        const addedQuestionIds = new Set();

        function getAnswerForQuestion(questionId) {
            return (
                props.answerList.find(function (answer) {
                    return answer.question === questionId;
                }) || {}
            );
        }

        function addQuestion(question) {
            if (!question) {
                return;
            }

            if (addedQuestionIds.has(question.uuid)) {
                return;
            }

            addedQuestionIds.add(question.uuid);
            qstnsArray.push(question);
        }

        function renderQuestions(section) {
            if (!section || !section.questions) {
                return;
            }

            var questions = section.questions;

            if (props.assessment_type === 'p') {
                var level1Qns = _.sortBy(
                    questions.filter(function (q) {
                        return q.level === 1;
                    }),
                    'level_order'
                );

                var level2Qns = _.sortBy(
                    questions.filter(function (q) {
                        return q.level === 2;
                    }),
                    'level_order'
                );

                var level3Qns = _.sortBy(
                    questions.filter(function (q) {
                        return q.level === 3;
                    }),
                    'level_order'
                );

                var level0Qns = _.sortBy(
                    questions.filter(function (q) {
                        return q.level === 0;
                    }),
                    'level_order'
                );

                questions = [
                    ...level1Qns,
                    ...level2Qns,
                    ...level3Qns,
                    ...level0Qns
                ];
            }

            questions.forEach(function (question) {
                addQuestion(question);
                getSubQuestions(question);
            });
        }

        function getSubQuestions(question) {
            if (
                question.ansType !== 'o' &&
                question.ansType !== 'm'
            ) {
                return;
            }

            var answer = getAnswerForQuestion(question.uuid);

            (question.options || []).forEach(function (option) {
                var isSelected =
                    option.uuid === answer.option ||
                    (
                        Array.isArray(answer.mOptions) &&
                        answer.mOptions.indexOf(option.uuid) !== -1
                    );

                if (isSelected && option.section) {
                    renderQuestions(option.section);
                }
            });
        }

        if (props.asmt && props.asmt.questionnaires) {
            props.asmt.questionnaires.forEach(function (questionnaire) {
                if (questionnaire.sections) {
                    questionnaire.sections.forEach(function (section) {
                        renderQuestions(section);
                    });
                }
            });
        }

        return qstnsArray;
    }, [props.asmt, props.answerList, props.assessment_type]);
    const answers = _.compact(
        _.map(total, question =>
            _.find(answeredNormalQns, { question: question.uuid })
        )
    );

    var percent =
        total.length > 0
            ? Math.round(
                  (answers.length / total.length) * 100
              )
            : 0;
    return (
        <Progress
            percent={percent}
            percentPosition={{
                align: 'center',
                type: 'outer'
            }}
            strokeColor="#339379"
            size="small"
        />
    );

}
export default connect()(QuestProgress);